module.exports = __webpack_public_path__ + "media/V47.3b7aa994.mp4";